import { c as _c } from "react/compiler-runtime";
import { LocaleEnum } from '@systemeio/ui';
import { AutomationsIcon, BlogsIcon, ContactsIcon, DashboardIcon, EmailsIcon, HelpIcon, ManInSuit, ProductsIcon, SalesIcon, SmsMenuIcon, UpgradeIcon } from '@systemeio/ui/icons';
import { useRouter } from 'next/router';
import { pageRoute } from 'shared/constants/routes.constants';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { usePermission } from 'shared/hooks/use-permission';
import useUser from 'shared/hooks/use-user';
import { formUrl } from 'shared/utils/links/form-url';
import { isSIO } from 'shared/utils/is-sio';
import { MenuItemType } from '../types/menu-interface';
import { getHelpPageUrl } from 'shared/components/header/utils/get-help-page-url';
export const useMenuItems = () => {
  const $ = _c(418);
  const {
    t
  } = useLocoTranslation();
  const {
    user,
    isWorkspaceOwner,
    isSupportImpersonation,
    isWsAssistant,
    isStudent
  } = useUser();
  const {
    pathname
  } = useRouter();
  const {
    pagePermissions,
    isReady
  } = usePermission();
  let t0;
  if ($[0] !== pathname) {
    t0 = url => pathname.includes(url);
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const regularIsActiveCheck = t0;
  let t1;
  if ($[2] !== pagePermissions) {
    t1 = route => Boolean(pagePermissions[pageRoute[route]]);
    $[2] = pagePermissions;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const hasPermission = t1;
  const t2 = user?.userPlanId === 40 && isWorkspaceOwner && !isSupportImpersonation;
  let t3;
  if ($[4] !== t) {
    t3 = t("header.top_menu.upgrade");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== regularIsActiveCheck || $[7] !== t2 || $[8] !== t3) {
    t4 = {
      href: pageRoute.ProfileUserPlan,
      shouldRender: t2,
      mobileIconRenderer: _temp,
      name: t3,
      isActive: regularIsActiveCheck
    };
    $[6] = regularIsActiveCheck;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t("header.top_menu.dashboard");
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("header.top_menu.main_dashboard");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = hasPermission("Dashboard");
  let t8;
  if ($[14] !== pathname) {
    t8 = url_0 => pathname === url_0;
    $[14] = pathname;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t6 || $[17] !== t7 || $[18] !== t8) {
    t9 = {
      name: t6,
      href: pageRoute.Dashboard,
      shouldRender: t7,
      isActive: t8
    };
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("header.top_menu.affiliate_dashboard");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const t11 = hasPermission("AffiliateDashboard");
  let t12;
  if ($[22] !== regularIsActiveCheck || $[23] !== t10 || $[24] !== t11) {
    t12 = {
      name: t10,
      href: pageRoute.AffiliateDashboard,
      shouldRender: t11,
      isActive: regularIsActiveCheck
    };
    $[22] = regularIsActiveCheck;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t) {
    t13 = t("header.top_menu.student_dashboard");
    $[26] = t;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== isStudent) {
    t14 = isStudent ? formUrl("/school", false) ?? "" : formUrl("/school?tab=explore_courses", false) ?? "";
    $[28] = isStudent;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== isStudent || $[31] !== regularIsActiveCheck || $[32] !== t13 || $[33] !== t14) {
    t15 = {
      name: t13,
      shouldRender: isStudent,
      href: t14,
      isActive: regularIsActiveCheck
    };
    $[30] = isStudent;
    $[31] = regularIsActiveCheck;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t) {
    t16 = t("header.top_menu.agency_dashboard");
    $[35] = t;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  const t17 = hasPermission("AgencyUsers");
  let t18;
  if ($[37] !== pathname) {
    t18 = () => pathname.includes("/agency-center");
    $[37] = pathname;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t16 || $[40] !== t17 || $[41] !== t18) {
    t19 = {
      name: t16,
      href: pageRoute.AgencyUsers,
      shouldRender: t17,
      isActive: t18
    };
    $[39] = t16;
    $[40] = t17;
    $[41] = t18;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== t12 || $[44] !== t15 || $[45] !== t19 || $[46] !== t9) {
    t20 = [t9, t12, t15, t19];
    $[43] = t12;
    $[44] = t15;
    $[45] = t19;
    $[46] = t9;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  let t21;
  if ($[48] !== t20 || $[49] !== t5) {
    t21 = {
      name: t5,
      dropdownItems: t20,
      mobileIconRenderer: _temp2
    };
    $[48] = t20;
    $[49] = t5;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] !== t) {
    t22 = t("header.top_menu.crm");
    $[51] = t;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== t) {
    t23 = t("header.top_menu.contacts");
    $[53] = t;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  const t24 = isWsAssistant ? pageRoute.AssistantContacts : pageRoute.Contacts;
  const t25 = isWsAssistant ? hasPermission("AssistantContacts") : hasPermission("Contacts");
  let t26;
  if ($[55] !== regularIsActiveCheck || $[56] !== t23 || $[57] !== t24 || $[58] !== t25) {
    t26 = {
      name: t23,
      href: t24,
      isActive: regularIsActiveCheck,
      shouldRender: t25
    };
    $[55] = regularIsActiveCheck;
    $[56] = t23;
    $[57] = t24;
    $[58] = t25;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] !== t) {
    t27 = t("header.top_menu.tags");
    $[60] = t;
    $[61] = t27;
  } else {
    t27 = $[61];
  }
  const t28 = hasPermission("Tags");
  let t29;
  if ($[62] !== regularIsActiveCheck || $[63] !== t27 || $[64] !== t28) {
    t29 = {
      name: t27,
      href: pageRoute.Tags,
      isActive: regularIsActiveCheck,
      shouldRender: t28
    };
    $[62] = regularIsActiveCheck;
    $[63] = t27;
    $[64] = t28;
    $[65] = t29;
  } else {
    t29 = $[65];
  }
  let t30;
  if ($[66] !== t) {
    t30 = t("header.top_menu.crm_pipeline");
    $[66] = t;
    $[67] = t30;
  } else {
    t30 = $[67];
  }
  const t31 = hasPermission("CrmPipeline");
  let t32;
  if ($[68] !== regularIsActiveCheck || $[69] !== t30 || $[70] !== t31) {
    t32 = {
      name: t30,
      href: pageRoute.CrmPipeline,
      isActive: regularIsActiveCheck,
      shouldRender: t31
    };
    $[68] = regularIsActiveCheck;
    $[69] = t30;
    $[70] = t31;
    $[71] = t32;
  } else {
    t32 = $[71];
  }
  let t33;
  if ($[72] !== t) {
    t33 = t("header.top_menu.calendar");
    $[72] = t;
    $[73] = t33;
  } else {
    t33 = $[73];
  }
  const t34 = hasPermission("Calendar");
  let t35;
  if ($[74] !== regularIsActiveCheck || $[75] !== t33 || $[76] !== t34) {
    t35 = {
      name: t33,
      href: pageRoute.Calendar,
      isActive: regularIsActiveCheck,
      shouldRender: t34
    };
    $[74] = regularIsActiveCheck;
    $[75] = t33;
    $[76] = t34;
    $[77] = t35;
  } else {
    t35 = $[77];
  }
  let t36;
  if ($[78] !== t26 || $[79] !== t29 || $[80] !== t32 || $[81] !== t35) {
    t36 = [t26, t29, t32, t35];
    $[78] = t26;
    $[79] = t29;
    $[80] = t32;
    $[81] = t35;
    $[82] = t36;
  } else {
    t36 = $[82];
  }
  let t37;
  if ($[83] !== t22 || $[84] !== t36) {
    t37 = {
      name: t22,
      dropdownItems: t36,
      mobileIconRenderer: _temp3
    };
    $[83] = t22;
    $[84] = t36;
    $[85] = t37;
  } else {
    t37 = $[85];
  }
  let t38;
  if ($[86] !== t) {
    t38 = t("header.top_menu.sites");
    $[86] = t;
    $[87] = t38;
  } else {
    t38 = $[87];
  }
  let t39;
  if ($[88] !== t) {
    t39 = t("header.top_menu.website");
    $[88] = t;
    $[89] = t39;
  } else {
    t39 = $[89];
  }
  const t40 = hasPermission("Websites");
  let t41;
  if ($[90] !== regularIsActiveCheck || $[91] !== t39 || $[92] !== t40) {
    t41 = {
      name: t39,
      href: pageRoute.Websites,
      shouldRender: t40,
      isActive: regularIsActiveCheck
    };
    $[90] = regularIsActiveCheck;
    $[91] = t39;
    $[92] = t40;
    $[93] = t41;
  } else {
    t41 = $[93];
  }
  let t42;
  if ($[94] !== t) {
    t42 = t("header.top_menu.funnels");
    $[94] = t;
    $[95] = t42;
  } else {
    t42 = $[95];
  }
  const t43 = hasPermission("Funnels");
  let t44;
  if ($[96] !== regularIsActiveCheck || $[97] !== t42 || $[98] !== t43) {
    t44 = {
      name: t42,
      href: pageRoute.Funnels,
      isActive: regularIsActiveCheck,
      shouldRender: t43
    };
    $[96] = regularIsActiveCheck;
    $[97] = t42;
    $[98] = t43;
    $[99] = t44;
  } else {
    t44 = $[99];
  }
  let t45;
  if ($[100] !== t) {
    t45 = t("header.top_menu.digital_stores");
    $[100] = t;
    $[101] = t45;
  } else {
    t45 = $[101];
  }
  const t46 = hasPermission("Stores");
  let t47;
  if ($[102] !== regularIsActiveCheck || $[103] !== t45 || $[104] !== t46) {
    t47 = {
      name: t45,
      href: pageRoute.Stores,
      isActive: regularIsActiveCheck,
      shouldRender: t46
    };
    $[102] = regularIsActiveCheck;
    $[103] = t45;
    $[104] = t46;
    $[105] = t47;
  } else {
    t47 = $[105];
  }
  let t48;
  if ($[106] !== t) {
    t48 = t("header.top_menu.blogs");
    $[106] = t;
    $[107] = t48;
  } else {
    t48 = $[107];
  }
  const t49 = hasPermission("Blogs");
  let t50;
  if ($[108] !== regularIsActiveCheck || $[109] !== t48 || $[110] !== t49) {
    t50 = {
      name: t48,
      href: pageRoute.Blogs,
      isActive: regularIsActiveCheck,
      shouldRender: t49
    };
    $[108] = regularIsActiveCheck;
    $[109] = t48;
    $[110] = t49;
    $[111] = t50;
  } else {
    t50 = $[111];
  }
  let t51;
  if ($[112] !== t41 || $[113] !== t44 || $[114] !== t47 || $[115] !== t50) {
    t51 = [t41, t44, t47, t50];
    $[112] = t41;
    $[113] = t44;
    $[114] = t47;
    $[115] = t50;
    $[116] = t51;
  } else {
    t51 = $[116];
  }
  let t52;
  if ($[117] !== t38 || $[118] !== t51) {
    t52 = {
      name: t38,
      dropdownItems: t51,
      mobileIconRenderer: _temp4
    };
    $[117] = t38;
    $[118] = t51;
    $[119] = t52;
  } else {
    t52 = $[119];
  }
  let t53;
  if ($[120] !== t) {
    t53 = t("header.top_menu.emails");
    $[120] = t;
    $[121] = t53;
  } else {
    t53 = $[121];
  }
  let t54;
  if ($[122] !== t) {
    t54 = t("header.top_menu.newsletters");
    $[122] = t;
    $[123] = t54;
  } else {
    t54 = $[123];
  }
  const t55 = hasPermission("Newsletters");
  let t56;
  if ($[124] !== regularIsActiveCheck || $[125] !== t54 || $[126] !== t55) {
    t56 = {
      name: t54,
      href: pageRoute.Newsletters,
      isActive: regularIsActiveCheck,
      shouldRender: t55
    };
    $[124] = regularIsActiveCheck;
    $[125] = t54;
    $[126] = t55;
    $[127] = t56;
  } else {
    t56 = $[127];
  }
  let t57;
  if ($[128] !== t) {
    t57 = t("header.top_menu.campaigns");
    $[128] = t;
    $[129] = t57;
  } else {
    t57 = $[129];
  }
  const t58 = hasPermission("Campaigns");
  let t59;
  if ($[130] !== regularIsActiveCheck || $[131] !== t57 || $[132] !== t58) {
    t59 = {
      name: t57,
      href: pageRoute.Campaigns,
      isActive: regularIsActiveCheck,
      shouldRender: t58
    };
    $[130] = regularIsActiveCheck;
    $[131] = t57;
    $[132] = t58;
    $[133] = t59;
  } else {
    t59 = $[133];
  }
  let t60;
  if ($[134] !== t) {
    t60 = t("header.top_menu.email_statistics");
    $[134] = t;
    $[135] = t60;
  } else {
    t60 = $[135];
  }
  const t61 = hasPermission("EmailStatistics");
  let t62;
  if ($[136] !== regularIsActiveCheck || $[137] !== t60 || $[138] !== t61) {
    t62 = {
      name: t60,
      href: pageRoute.EmailStatistics,
      isActive: regularIsActiveCheck,
      shouldRender: t61
    };
    $[136] = regularIsActiveCheck;
    $[137] = t60;
    $[138] = t61;
    $[139] = t62;
  } else {
    t62 = $[139];
  }
  let t63;
  if ($[140] !== t56 || $[141] !== t59 || $[142] !== t62) {
    t63 = [t56, t59, t62];
    $[140] = t56;
    $[141] = t59;
    $[142] = t62;
    $[143] = t63;
  } else {
    t63 = $[143];
  }
  let t64;
  if ($[144] !== t53 || $[145] !== t63) {
    t64 = {
      name: t53,
      dropdownItems: t63,
      mobileIconRenderer: _temp5
    };
    $[144] = t53;
    $[145] = t63;
    $[146] = t64;
  } else {
    t64 = $[146];
  }
  let t65;
  if ($[147] !== t) {
    t65 = t("header.top_menu.sms");
    $[147] = t;
    $[148] = t65;
  } else {
    t65 = $[148];
  }
  let t66;
  if ($[149] !== t) {
    t66 = t("header.top_menu.sms_templates");
    $[149] = t;
    $[150] = t66;
  } else {
    t66 = $[150];
  }
  const t67 = hasPermission("SmsTemplates");
  let t68;
  if ($[151] !== regularIsActiveCheck || $[152] !== t66 || $[153] !== t67) {
    t68 = {
      name: t66,
      href: pageRoute.SmsTemplates,
      isActive: regularIsActiveCheck,
      shouldRender: t67
    };
    $[151] = regularIsActiveCheck;
    $[152] = t66;
    $[153] = t67;
    $[154] = t68;
  } else {
    t68 = $[154];
  }
  let t69;
  if ($[155] !== t) {
    t69 = t("header.top_menu.sms_statistics");
    $[155] = t;
    $[156] = t69;
  } else {
    t69 = $[156];
  }
  const t70 = hasPermission("SmsStatistics");
  let t71;
  if ($[157] !== regularIsActiveCheck || $[158] !== t69 || $[159] !== t70) {
    t71 = {
      name: t69,
      href: pageRoute.SmsStatistics,
      isActive: regularIsActiveCheck,
      shouldRender: t70
    };
    $[157] = regularIsActiveCheck;
    $[158] = t69;
    $[159] = t70;
    $[160] = t71;
  } else {
    t71 = $[160];
  }
  let t72;
  if ($[161] !== t68 || $[162] !== t71) {
    t72 = [t68, t71];
    $[161] = t68;
    $[162] = t71;
    $[163] = t72;
  } else {
    t72 = $[163];
  }
  let t73;
  if ($[164] !== t65 || $[165] !== t72) {
    t73 = {
      name: t65,
      dropdownItems: t72,
      mobileIconRenderer: _temp6
    };
    $[164] = t65;
    $[165] = t72;
    $[166] = t73;
  } else {
    t73 = $[166];
  }
  let t74;
  if ($[167] !== t) {
    t74 = t("header.top_menu.automations");
    $[167] = t;
    $[168] = t74;
  } else {
    t74 = $[168];
  }
  let t75;
  if ($[169] !== t) {
    t75 = t("header.top_menu.rules");
    $[169] = t;
    $[170] = t75;
  } else {
    t75 = $[170];
  }
  const t76 = hasPermission("AutomationRules");
  let t77;
  if ($[171] !== regularIsActiveCheck || $[172] !== t75 || $[173] !== t76) {
    t77 = {
      name: t75,
      href: pageRoute.AutomationRules,
      isActive: regularIsActiveCheck,
      shouldRender: t76
    };
    $[171] = regularIsActiveCheck;
    $[172] = t75;
    $[173] = t76;
    $[174] = t77;
  } else {
    t77 = $[174];
  }
  let t78;
  if ($[175] !== t) {
    t78 = t("header.top_menu.workflows");
    $[175] = t;
    $[176] = t78;
  } else {
    t78 = $[176];
  }
  const t79 = hasPermission("Workflows");
  let t80;
  if ($[177] !== regularIsActiveCheck || $[178] !== t78 || $[179] !== t79) {
    t80 = {
      name: t78,
      href: pageRoute.Workflows,
      isActive: regularIsActiveCheck,
      shouldRender: t79
    };
    $[177] = regularIsActiveCheck;
    $[178] = t78;
    $[179] = t79;
    $[180] = t80;
  } else {
    t80 = $[180];
  }
  let t81;
  if ($[181] !== t77 || $[182] !== t80) {
    t81 = [t77, t80];
    $[181] = t77;
    $[182] = t80;
    $[183] = t81;
  } else {
    t81 = $[183];
  }
  let t82;
  if ($[184] !== t74 || $[185] !== t81) {
    t82 = {
      name: t74,
      dropdownItems: t81,
      mobileIconRenderer: _temp7
    };
    $[184] = t74;
    $[185] = t81;
    $[186] = t82;
  } else {
    t82 = $[186];
  }
  let t83;
  if ($[187] !== t) {
    t83 = t("header.top_menu.products");
    $[187] = t;
    $[188] = t83;
  } else {
    t83 = $[188];
  }
  let t84;
  if ($[189] !== t) {
    t84 = t("header.top_menu.physical_product");
    $[189] = t;
    $[190] = t84;
  } else {
    t84 = $[190];
  }
  const t85 = hasPermission("Products");
  let t86;
  if ($[191] !== regularIsActiveCheck || $[192] !== t84 || $[193] !== t85) {
    t86 = {
      name: t84,
      href: pageRoute.Products,
      isActive: regularIsActiveCheck,
      shouldRender: t85
    };
    $[191] = regularIsActiveCheck;
    $[192] = t84;
    $[193] = t85;
    $[194] = t86;
  } else {
    t86 = $[194];
  }
  let t87;
  if ($[195] !== t) {
    t87 = t("header.top_menu.coupons");
    $[195] = t;
    $[196] = t87;
  } else {
    t87 = $[196];
  }
  const t88 = hasPermission("Coupons");
  let t89;
  if ($[197] !== regularIsActiveCheck || $[198] !== t87 || $[199] !== t88) {
    t89 = {
      name: t87,
      href: pageRoute.Coupons,
      isActive: regularIsActiveCheck,
      shouldRender: t88
    };
    $[197] = regularIsActiveCheck;
    $[198] = t87;
    $[199] = t88;
    $[200] = t89;
  } else {
    t89 = $[200];
  }
  let t90;
  if ($[201] !== t) {
    t90 = t("header.top_menu.courses");
    $[201] = t;
    $[202] = t90;
  } else {
    t90 = $[202];
  }
  const t91 = hasPermission("Courses");
  let t92;
  if ($[203] !== regularIsActiveCheck || $[204] !== t90 || $[205] !== t91) {
    t92 = {
      name: t90,
      href: pageRoute.Courses,
      isActive: regularIsActiveCheck,
      shouldRender: t91
    };
    $[203] = regularIsActiveCheck;
    $[204] = t90;
    $[205] = t91;
    $[206] = t92;
  } else {
    t92 = $[206];
  }
  let t93;
  if ($[207] !== t) {
    t93 = t("header.top_menu.communities");
    $[207] = t;
    $[208] = t93;
  } else {
    t93 = $[208];
  }
  const t94 = hasPermission("Communities");
  let t95;
  if ($[209] !== regularIsActiveCheck || $[210] !== t93 || $[211] !== t94) {
    t95 = {
      name: t93,
      href: pageRoute.Communities,
      isActive: regularIsActiveCheck,
      shouldRender: t94
    };
    $[209] = regularIsActiveCheck;
    $[210] = t93;
    $[211] = t94;
    $[212] = t95;
  } else {
    t95 = $[212];
  }
  let t96;
  if ($[213] !== t) {
    t96 = t("header.top_menu.files");
    $[213] = t;
    $[214] = t96;
  } else {
    t96 = $[214];
  }
  const t97 = hasPermission("Files");
  let t98;
  if ($[215] !== regularIsActiveCheck || $[216] !== t96 || $[217] !== t97) {
    t98 = {
      name: t96,
      href: pageRoute.Files,
      isActive: regularIsActiveCheck,
      shouldRender: t97
    };
    $[215] = regularIsActiveCheck;
    $[216] = t96;
    $[217] = t97;
    $[218] = t98;
  } else {
    t98 = $[218];
  }
  let t99;
  if ($[219] !== t86 || $[220] !== t89 || $[221] !== t92 || $[222] !== t95 || $[223] !== t98) {
    t99 = [t86, t89, t92, t95, t98];
    $[219] = t86;
    $[220] = t89;
    $[221] = t92;
    $[222] = t95;
    $[223] = t98;
    $[224] = t99;
  } else {
    t99 = $[224];
  }
  let t100;
  if ($[225] !== t83 || $[226] !== t99) {
    t100 = {
      name: t83,
      dropdownItems: t99,
      mobileIconRenderer: _temp8
    };
    $[225] = t83;
    $[226] = t99;
    $[227] = t100;
  } else {
    t100 = $[227];
  }
  let t101;
  if ($[228] !== t) {
    t101 = t("header.top_menu.sales");
    $[228] = t;
    $[229] = t101;
  } else {
    t101 = $[229];
  }
  let t102;
  if ($[230] !== t) {
    t102 = t("header.top_menu.orders");
    $[230] = t;
    $[231] = t102;
  } else {
    t102 = $[231];
  }
  const t103 = hasPermission("Orders");
  let t104;
  if ($[232] !== regularIsActiveCheck || $[233] !== t102 || $[234] !== t103) {
    t104 = {
      name: t102,
      href: pageRoute.Orders,
      isActive: regularIsActiveCheck,
      shouldRender: t103
    };
    $[232] = regularIsActiveCheck;
    $[233] = t102;
    $[234] = t103;
    $[235] = t104;
  } else {
    t104 = $[235];
  }
  let t105;
  if ($[236] !== t) {
    t105 = t("header.top_menu.transactions");
    $[236] = t;
    $[237] = t105;
  } else {
    t105 = $[237];
  }
  const t106 = hasPermission("Transactions");
  let t107;
  if ($[238] !== regularIsActiveCheck || $[239] !== t105 || $[240] !== t106) {
    t107 = {
      name: t105,
      href: pageRoute.Transactions,
      isActive: regularIsActiveCheck,
      shouldRender: t106
    };
    $[238] = regularIsActiveCheck;
    $[239] = t105;
    $[240] = t106;
    $[241] = t107;
  } else {
    t107 = $[241];
  }
  let t108;
  if ($[242] !== t) {
    t108 = t("header.top_menu.subscriptions");
    $[242] = t;
    $[243] = t108;
  } else {
    t108 = $[243];
  }
  const t109 = hasPermission("Subscriptions");
  let t110;
  if ($[244] !== regularIsActiveCheck || $[245] !== t108 || $[246] !== t109) {
    t110 = {
      name: t108,
      href: pageRoute.Subscriptions,
      isActive: regularIsActiveCheck,
      shouldRender: t109
    };
    $[244] = regularIsActiveCheck;
    $[245] = t108;
    $[246] = t109;
    $[247] = t110;
  } else {
    t110 = $[247];
  }
  let t111;
  if ($[248] !== t) {
    t111 = t("header.top_menu.affiliate_invoices");
    $[248] = t;
    $[249] = t111;
  } else {
    t111 = $[249];
  }
  const t112 = hasPermission("AffiliateInvoices");
  let t113;
  if ($[250] !== regularIsActiveCheck || $[251] !== t111 || $[252] !== t112) {
    t113 = {
      name: t111,
      href: pageRoute.AffiliateInvoices,
      shouldRender: t112,
      isActive: regularIsActiveCheck
    };
    $[250] = regularIsActiveCheck;
    $[251] = t111;
    $[252] = t112;
    $[253] = t113;
  } else {
    t113 = $[253];
  }
  let t114;
  if ($[254] !== t) {
    t114 = t("header.top_menu.affiliate_program");
    $[254] = t;
    $[255] = t114;
  } else {
    t114 = $[255];
  }
  const t115 = hasPermission("AffiliateProgram");
  let t116;
  if ($[256] !== regularIsActiveCheck || $[257] !== t114 || $[258] !== t115) {
    t116 = {
      name: t114,
      href: pageRoute.AffiliateProgram,
      shouldRender: t115,
      isActive: regularIsActiveCheck
    };
    $[256] = regularIsActiveCheck;
    $[257] = t114;
    $[258] = t115;
    $[259] = t116;
  } else {
    t116 = $[259];
  }
  let t117;
  if ($[260] !== t104 || $[261] !== t107 || $[262] !== t110 || $[263] !== t113 || $[264] !== t116) {
    t117 = [t104, t107, t110, t113, t116];
    $[260] = t104;
    $[261] = t107;
    $[262] = t110;
    $[263] = t113;
    $[264] = t116;
    $[265] = t117;
  } else {
    t117 = $[265];
  }
  let t118;
  if ($[266] !== t101 || $[267] !== t117) {
    t118 = {
      name: t101,
      dropdownItems: t117,
      mobileIconRenderer: _temp9
    };
    $[266] = t101;
    $[267] = t117;
    $[268] = t118;
  } else {
    t118 = $[268];
  }
  let t119;
  if ($[269] !== t) {
    t119 = t("header.top_menu.admin.admin");
    $[269] = t;
    $[270] = t119;
  } else {
    t119 = $[270];
  }
  let t120;
  if ($[271] !== t) {
    t120 = t("header.top_menu.admin.users");
    $[271] = t;
    $[272] = t120;
  } else {
    t120 = $[272];
  }
  const t121 = hasPermission("AdminUsers");
  let t122;
  if ($[273] !== regularIsActiveCheck || $[274] !== t120 || $[275] !== t121) {
    t122 = {
      name: t120,
      href: pageRoute.AdminUsers,
      shouldRender: t121,
      isActive: regularIsActiveCheck
    };
    $[273] = regularIsActiveCheck;
    $[274] = t120;
    $[275] = t121;
    $[276] = t122;
  } else {
    t122 = $[276];
  }
  let t123;
  if ($[277] !== t) {
    t123 = t("header.top_menu.admin.templates");
    $[277] = t;
    $[278] = t123;
  } else {
    t123 = $[278];
  }
  let t124;
  if ($[279] !== t) {
    t124 = t("header.top_menu.admin.email_templates");
    $[279] = t;
    $[280] = t124;
  } else {
    t124 = $[280];
  }
  const t125 = hasPermission("AdminEmailTemplates");
  let t126;
  if ($[281] !== regularIsActiveCheck || $[282] !== t124 || $[283] !== t125) {
    t126 = {
      name: t124,
      href: pageRoute.AdminEmailTemplates,
      isActive: regularIsActiveCheck,
      shouldRender: t125
    };
    $[281] = regularIsActiveCheck;
    $[282] = t124;
    $[283] = t125;
    $[284] = t126;
  } else {
    t126 = $[284];
  }
  let t127;
  if ($[285] !== t) {
    t127 = t("header.top_menu.admin.page_templates");
    $[285] = t;
    $[286] = t127;
  } else {
    t127 = $[286];
  }
  const t128 = hasPermission("AdminPageTemplates");
  let t129;
  if ($[287] !== regularIsActiveCheck || $[288] !== t127 || $[289] !== t128) {
    t129 = {
      name: t127,
      href: pageRoute.AdminPageTemplates,
      isActive: regularIsActiveCheck,
      shouldRender: t128
    };
    $[287] = regularIsActiveCheck;
    $[288] = t127;
    $[289] = t128;
    $[290] = t129;
  } else {
    t129 = $[290];
  }
  let t130;
  if ($[291] !== t) {
    t130 = t("header.top_menu.admin.blog_templates");
    $[291] = t;
    $[292] = t130;
  } else {
    t130 = $[292];
  }
  const t131 = hasPermission("AdminBlogTemplates");
  let t132;
  if ($[293] !== regularIsActiveCheck || $[294] !== t130 || $[295] !== t131) {
    t132 = {
      name: t130,
      href: pageRoute.AdminBlogTemplates,
      isActive: regularIsActiveCheck,
      shouldRender: t131
    };
    $[293] = regularIsActiveCheck;
    $[294] = t130;
    $[295] = t131;
    $[296] = t132;
  } else {
    t132 = $[296];
  }
  let t133;
  if ($[297] !== t) {
    t133 = t("header.top_menu.admin.website_templates");
    $[297] = t;
    $[298] = t133;
  } else {
    t133 = $[298];
  }
  const t134 = hasPermission("AdminWebsiteTemplates");
  let t135;
  if ($[299] !== regularIsActiveCheck || $[300] !== t133 || $[301] !== t134) {
    t135 = {
      name: t133,
      href: pageRoute.AdminWebsiteTemplates,
      shouldRender: t134,
      isActive: regularIsActiveCheck
    };
    $[299] = regularIsActiveCheck;
    $[300] = t133;
    $[301] = t134;
    $[302] = t135;
  } else {
    t135 = $[302];
  }
  let t136;
  if ($[303] !== t) {
    t136 = t("header.top_menu.admin.funnel_templates");
    $[303] = t;
    $[304] = t136;
  } else {
    t136 = $[304];
  }
  const t137 = hasPermission("AdminFunnelTemplates");
  let t138;
  if ($[305] !== regularIsActiveCheck || $[306] !== t136 || $[307] !== t137) {
    t138 = {
      name: t136,
      href: pageRoute.AdminFunnelTemplates,
      isActive: regularIsActiveCheck,
      shouldRender: t137
    };
    $[305] = regularIsActiveCheck;
    $[306] = t136;
    $[307] = t137;
    $[308] = t138;
  } else {
    t138 = $[308];
  }
  let t139;
  if ($[309] !== t126 || $[310] !== t129 || $[311] !== t132 || $[312] !== t135 || $[313] !== t138) {
    t139 = [t126, t129, t132, t135, t138];
    $[309] = t126;
    $[310] = t129;
    $[311] = t132;
    $[312] = t135;
    $[313] = t138;
    $[314] = t139;
  } else {
    t139 = $[314];
  }
  let t140;
  if ($[315] !== t123 || $[316] !== t139) {
    t140 = {
      name: t123,
      dropdownItems: t139
    };
    $[315] = t123;
    $[316] = t139;
    $[317] = t140;
  } else {
    t140 = $[317];
  }
  let t141;
  if ($[318] !== t) {
    t141 = t("header.top_menu.admin.customers");
    $[318] = t;
    $[319] = t141;
  } else {
    t141 = $[319];
  }
  const t142 = hasPermission("AdminCustomers");
  let t143;
  if ($[320] !== regularIsActiveCheck || $[321] !== t141 || $[322] !== t142) {
    t143 = {
      name: t141,
      href: pageRoute.AdminCustomers,
      shouldRender: t142,
      isActive: regularIsActiveCheck
    };
    $[320] = regularIsActiveCheck;
    $[321] = t141;
    $[322] = t142;
    $[323] = t143;
  } else {
    t143 = $[323];
  }
  let t144;
  if ($[324] !== t) {
    t144 = t("header.top_menu.admin.emails");
    $[324] = t;
    $[325] = t144;
  } else {
    t144 = $[325];
  }
  const t145 = hasPermission("AdminEmailStats");
  let t146;
  if ($[326] !== regularIsActiveCheck || $[327] !== t144 || $[328] !== t145) {
    t146 = {
      name: t144,
      href: pageRoute.AdminEmailStats,
      shouldRender: t145,
      isActive: regularIsActiveCheck
    };
    $[326] = regularIsActiveCheck;
    $[327] = t144;
    $[328] = t145;
    $[329] = t146;
  } else {
    t146 = $[329];
  }
  let t147;
  if ($[330] !== t) {
    t147 = t("header.top_menu.admin.user_plans");
    $[330] = t;
    $[331] = t147;
  } else {
    t147 = $[331];
  }
  const t148 = hasPermission("AdminUserPlans");
  let t149;
  if ($[332] !== regularIsActiveCheck || $[333] !== t147 || $[334] !== t148) {
    t149 = {
      name: t147,
      href: pageRoute.AdminUserPlans,
      shouldRender: t148,
      isActive: regularIsActiveCheck
    };
    $[332] = regularIsActiveCheck;
    $[333] = t147;
    $[334] = t148;
    $[335] = t149;
  } else {
    t149 = $[335];
  }
  let t150;
  if ($[336] !== t) {
    t150 = t("header.top_menu.admin.domains_blocked");
    $[336] = t;
    $[337] = t150;
  } else {
    t150 = $[337];
  }
  const t151 = hasPermission("AdminDomainsBlocked");
  let t152;
  if ($[338] !== regularIsActiveCheck || $[339] !== t150 || $[340] !== t151) {
    t152 = {
      name: t150,
      href: pageRoute.AdminDomainsBlocked,
      shouldRender: t151,
      isActive: regularIsActiveCheck
    };
    $[338] = regularIsActiveCheck;
    $[339] = t150;
    $[340] = t151;
    $[341] = t152;
  } else {
    t152 = $[341];
  }
  let t153;
  if ($[342] !== t) {
    t153 = t("header.top_menu.admin.domains_white_listed");
    $[342] = t;
    $[343] = t153;
  } else {
    t153 = $[343];
  }
  const t154 = hasPermission("AdminDomainsWhitelist");
  let t155;
  if ($[344] !== regularIsActiveCheck || $[345] !== t153 || $[346] !== t154) {
    t155 = {
      name: t153,
      href: pageRoute.AdminDomainsWhitelist,
      shouldRender: t154,
      isActive: regularIsActiveCheck
    };
    $[344] = regularIsActiveCheck;
    $[345] = t153;
    $[346] = t154;
    $[347] = t155;
  } else {
    t155 = $[347];
  }
  let t156;
  if ($[348] !== t) {
    t156 = t("header.top_menu.admin.suspicious_content");
    $[348] = t;
    $[349] = t156;
  } else {
    t156 = $[349];
  }
  let t157;
  if ($[350] !== t) {
    t157 = t("header.top_menu.admin.suspicious_page_content_keywords");
    $[350] = t;
    $[351] = t157;
  } else {
    t157 = $[351];
  }
  const t158 = hasPermission("AdminSuspiciousPageKeywords");
  let t159;
  if ($[352] !== regularIsActiveCheck || $[353] !== t157 || $[354] !== t158) {
    t159 = {
      name: t157,
      href: pageRoute.AdminSuspiciousPageKeywords,
      isActive: regularIsActiveCheck,
      shouldRender: t158
    };
    $[352] = regularIsActiveCheck;
    $[353] = t157;
    $[354] = t158;
    $[355] = t159;
  } else {
    t159 = $[355];
  }
  let t160;
  if ($[356] !== t) {
    t160 = t("header.top_menu.admin.suspicious_email_keywords");
    $[356] = t;
    $[357] = t160;
  } else {
    t160 = $[357];
  }
  const t161 = hasPermission("AdminSuspiciousEmailKeywords");
  let t162;
  if ($[358] !== regularIsActiveCheck || $[359] !== t160 || $[360] !== t161) {
    t162 = {
      name: t160,
      href: pageRoute.AdminSuspiciousEmailKeywords,
      isActive: regularIsActiveCheck,
      shouldRender: t161
    };
    $[358] = regularIsActiveCheck;
    $[359] = t160;
    $[360] = t161;
    $[361] = t162;
  } else {
    t162 = $[361];
  }
  let t163;
  if ($[362] !== t) {
    t163 = t("header.top_menu.admin.suspicious_email_address");
    $[362] = t;
    $[363] = t163;
  } else {
    t163 = $[363];
  }
  const t164 = hasPermission("AdminSuspiciousEmailAddress");
  let t165;
  if ($[364] !== regularIsActiveCheck || $[365] !== t163 || $[366] !== t164) {
    t165 = {
      name: t163,
      href: pageRoute.AdminSuspiciousEmailAddress,
      isActive: regularIsActiveCheck,
      shouldRender: t164
    };
    $[364] = regularIsActiveCheck;
    $[365] = t163;
    $[366] = t164;
    $[367] = t165;
  } else {
    t165 = $[367];
  }
  let t166;
  if ($[368] !== t159 || $[369] !== t162 || $[370] !== t165) {
    t166 = [t159, t162, t165];
    $[368] = t159;
    $[369] = t162;
    $[370] = t165;
    $[371] = t166;
  } else {
    t166 = $[371];
  }
  let t167;
  if ($[372] !== t156 || $[373] !== t166) {
    t167 = {
      name: t156,
      dropdownItems: t166
    };
    $[372] = t156;
    $[373] = t166;
    $[374] = t167;
  } else {
    t167 = $[374];
  }
  let t168;
  if ($[375] !== t) {
    t168 = t("header.top_menu.admin.statistics");
    $[375] = t;
    $[376] = t168;
  } else {
    t168 = $[376];
  }
  const t169 = hasPermission("AdminStatistics");
  let t170;
  if ($[377] !== regularIsActiveCheck || $[378] !== t168 || $[379] !== t169) {
    t170 = {
      name: t168,
      href: pageRoute.AdminStatistics,
      shouldRender: t169,
      isActive: regularIsActiveCheck
    };
    $[377] = regularIsActiveCheck;
    $[378] = t168;
    $[379] = t169;
    $[380] = t170;
  } else {
    t170 = $[380];
  }
  let t171;
  if ($[381] !== t122 || $[382] !== t140 || $[383] !== t143 || $[384] !== t146 || $[385] !== t149 || $[386] !== t152 || $[387] !== t155 || $[388] !== t167 || $[389] !== t170) {
    t171 = [t122, t140, t143, t146, t149, t152, t155, t167, t170];
    $[381] = t122;
    $[382] = t140;
    $[383] = t143;
    $[384] = t146;
    $[385] = t149;
    $[386] = t152;
    $[387] = t155;
    $[388] = t167;
    $[389] = t170;
    $[390] = t171;
  } else {
    t171 = $[390];
  }
  let t172;
  if ($[391] !== t119 || $[392] !== t171) {
    t172 = {
      name: t119,
      dropdownItems: t171,
      mobileIconRenderer: _temp10
    };
    $[391] = t119;
    $[392] = t171;
    $[393] = t172;
  } else {
    t172 = $[393];
  }
  let t173;
  if ($[394] !== t) {
    t173 = t("header.top_menu.help");
    $[394] = t;
    $[395] = t173;
  } else {
    t173 = $[395];
  }
  const t174 = user?.dashboardLocale ? user.dashboardLocale : LocaleEnum.ENGLISH;
  let t175;
  if ($[396] !== t174) {
    t175 = getHelpPageUrl(t174);
    $[396] = t174;
    $[397] = t175;
  } else {
    t175 = $[397];
  }
  let t176;
  if ($[398] === Symbol.for("react.memo_cache_sentinel")) {
    t176 = isSIO();
    $[398] = t176;
  } else {
    t176 = $[398];
  }
  let t177;
  if ($[399] !== regularIsActiveCheck || $[400] !== t173 || $[401] !== t175) {
    t177 = {
      name: t173,
      href: t175,
      target: "__blank",
      mobileIconRenderer: _temp11,
      shouldRender: t176,
      isActive: regularIsActiveCheck
    };
    $[399] = regularIsActiveCheck;
    $[400] = t173;
    $[401] = t175;
    $[402] = t177;
  } else {
    t177 = $[402];
  }
  let t178;
  if ($[403] !== t100 || $[404] !== t118 || $[405] !== t172 || $[406] !== t177 || $[407] !== t21 || $[408] !== t37 || $[409] !== t4 || $[410] !== t52 || $[411] !== t64 || $[412] !== t73 || $[413] !== t82) {
    t178 = [t4, t21, t37, t52, t64, t73, t82, t100, t118, t172, t177];
    $[403] = t100;
    $[404] = t118;
    $[405] = t172;
    $[406] = t177;
    $[407] = t21;
    $[408] = t37;
    $[409] = t4;
    $[410] = t52;
    $[411] = t64;
    $[412] = t73;
    $[413] = t82;
    $[414] = t178;
  } else {
    t178 = $[414];
  }
  const menuItems = t178;
  let t179;
  if ($[415] !== isReady || $[416] !== menuItems) {
    t179 = {
      menuItems,
      isReady
    };
    $[415] = isReady;
    $[416] = menuItems;
    $[417] = t179;
  } else {
    t179 = $[417];
  }
  return t179;
};
function _temp() {
  return <UpgradeIcon />;
}
function _temp2() {
  return <DashboardIcon />;
}
function _temp3() {
  return <ContactsIcon />;
}
function _temp4() {
  return <BlogsIcon />;
}
function _temp5() {
  return <EmailsIcon />;
}
function _temp6() {
  return <SmsMenuIcon />;
}
function _temp7() {
  return <AutomationsIcon />;
}
function _temp8() {
  return <ProductsIcon />;
}
function _temp9() {
  return <SalesIcon />;
}
function _temp10() {
  return <ManInSuit />;
}
function _temp11() {
  return <HelpIcon />;
}